module.exports = __webpack_public_path__ + "img/sticker3.3c27a955.png";